"use client";
import { jsx as a } from "react/jsx-runtime";
import c from "clsx";
import { Box as i } from "../base/Base.js";
import '../../assets/RatingStar.css';const n = "_star_g4vm5_1", e = "__active_g4vm5_11", _ = "_icon_g4vm5_14", t = {
  star: n,
  _active: e,
  icon: _
}, g = ({
  active: r,
  rating: o,
  ...s
}) => /* @__PURE__ */ a(
  "div",
  {
    className: c(t.star, { [t._active]: r }),
    "data-rating": o,
    ...s,
    children: /* @__PURE__ */ a(
      i,
      {
        center: !0,
        className: c("material-icons", t.icon),
        "data-icon": "star"
      }
    )
  }
);
export {
  g as RatingStar
};
